import urlParse from 'url-parse'
import queryString from 'query-string';

function getHost() {
  const url = urlParse();
  return `${url.protocol}${url.slashes ? '//' : ''}${url.host}`;
}

function resolvePromise(resolve, err, result) {
  if (err) {
    resolve({
      isSuccess: false,
      error: err
    });
  }
  else {
    resolve({
      isSuccess: true,
      result: result
    });
  }
}

function signUpWithAuth0(user, userMetadata, webAuth, auth0Realm) {
  const host = getHost();
  return new Promise((resolve, reject) => {
    webAuth.signupAndAuthorize({
      connection: auth0Realm,
      email: user.email,
      password: user.password,
      user_metadata: userMetadata,
      redirect_uri: `${host}/welcome`
    }, function (err, authResult) {
      resolvePromise(resolve, err, authResult);
    });
  });
}

function redirectAuth0(invitationToken, customRedirect, webAuth, auth0Realm) {
  const host = getHost();

  const q = queryString.stringify({ invitationToken: invitationToken, customRedirect: customRedirect });
  return new Promise((resolve, reject) => {
    webAuth.authorize({
      responseType: 'id_token',
      redirect_uri: `${host}/authenticate?${q}`
    }, function (err, authResult) {
      resolvePromise(resolve, err, authResult);
    });
  });
}

function logoutAuth0(invitationToken, webAuth, auth0Realm) {
  const host = getHost();
  return new Promise((resolve, reject) => {
    webAuth.logout({
      returnTo: `${host}/logged-out${invitationToken ? `?invitationToken=${invitationToken}` : ''}`
    }, function (err, authResult) {
      resolvePromise(resolve, err, authResult);
    });
  });
}

function userInfoAuth0(accessToken, webAuth, auth0Realm) {
  return new Promise((resolve, reject) => {
    webAuth.client.userInfo(accessToken, function (err, authResult) {
      resolvePromise(resolve, err, authResult);
    });
  });
}

function sendResetPasswordEmailAuth0(email, webAuth, auth0Realm) {
  return new Promise((resolve, reject) => {
    webAuth.changePassword({
      connection: auth0Realm,
      email: email
    }, function (err, authResult) {
      resolvePromise(resolve, err, authResult);
    });
  });
}

function sendUserMetadataAuth0(userId, metadata, webManagement, auth0Realm) {
  return new Promise((resolve, reject) => {
    webManagement.patchUserMetadata(userId, metadata, function (err, authResult) {
      resolvePromise(resolve, err, authResult);
    });
  });
}

export {
  signUpWithAuth0,
  redirectAuth0,
  logoutAuth0,
  userInfoAuth0,
  sendResetPasswordEmailAuth0,
  sendUserMetadataAuth0
};



// WEBPACK FOOTER //
// ./src/remote-apis/auth0-apis.js